import { render, staticRenderFns } from "./SendReports.vue?vue&type=template&id=f203c894"
import script from "./SendReports.vue?vue&type=script&lang=ts"
export * from "./SendReports.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports